import React from "react";
import { Router } from '@reach/router';
import JobDetail from '../../components/JobDetail';

const Job = () => (
  <Router>
    <JobDetail exact path="/careers/apply/:id" />
    <JobDetail path="/careers/apply/" />
  </Router>
)

export default Job;

